/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TeamMeetingActionItem
 */
export interface TeamMeetingActionItem {
  /**
   *
   * @type {string}
   * @memberof TeamMeetingActionItem
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof TeamMeetingActionItem
   */
  assignee?: string | null;
}

/**
 * Check if a given object implements the TeamMeetingActionItem interface.
 */
export function instanceOfTeamMeetingActionItem(
  value: object,
): value is TeamMeetingActionItem {
  if (!("content" in value) || value["content"] === undefined) return false;
  return true;
}

export function TeamMeetingActionItemFromJSON(
  json: any,
): TeamMeetingActionItem {
  return TeamMeetingActionItemFromJSONTyped(json, false);
}

export function TeamMeetingActionItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMeetingActionItem {
  if (json == null) {
    return json;
  }
  return {
    content: json["content"],
    assignee: json["assignee"] == null ? undefined : json["assignee"],
  };
}

export function TeamMeetingActionItemToJSON(json: any): TeamMeetingActionItem {
  return TeamMeetingActionItemToJSONTyped(json, false);
}

export function TeamMeetingActionItemToJSONTyped(
  value?: TeamMeetingActionItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    content: value["content"],
    assignee: value["assignee"],
  };
}
